import React, { Component } from "react";
import * as Constanti from '../../Utils/constants.js';
import '../../style/categoriauno.css';
import '../../style/generic.css';
import { Link } from "react-router";
import moment from "moment";


class BoxInEvidenzaHome extends Component{
  constructor(props){
    
    super(props);
}

  render(){
    const { video } = this.props;
  return (
    <>
    { video != null &&
<section className="categorysection darkblue-bg relative">
 <div className="hero-img">
    <img src={Constanti.url_img_new+video.thumbnail} alt="" className="img-hero"/>
    </div>
    <div className="hero-leftcategory"></div>
      <div className="hero-video-info height-100">
      <div className="container textWhite height-100">
      <div className="flex vertical align-start justify-end height-100">
        <div className="HeroTitle padding-bottom-16 padding-top-32">
         {video.title}
          </div>
          <div className="HeroCatDesc padding-bottom-32">
         {video.data_pubblicazione != null ? moment(video.data_pubblicazione).format('DD/MM/YYYY'): ""}
          </div>
           <div className="buttonHero">
           <Link to={'/video/'+video.id}>
          <button className="buttonVideo cursor-pointer"> Vai al video</button>
          </Link>
          </div>
      </div>
    </div>
    </div>
   </section>
    }
    </>
    )
}
}
export default BoxInEvidenzaHome; 





